import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function DeleteModal({ onConfirm, loading, flag }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleConfirm = () => {
        onConfirm();
        handleClose();
    };

    return (
        <>
            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        Delete
                    </Tooltip>
                }
            >
                <img src="/images/png/delete.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='md' centered scrollable onHide={handleClose}>
                <Modal.Header className='border-0 pb-0 pt-4' closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className='delete-modal'>
                        <img src="/images/png/delete-modal.png" className='delete-modal d-flex m-auto' alt="" />
                        <h6>Are you sure you want to delete this {flag} ?</h6>

                        <div className="col-12 d-flex justify-content-center gap-3">
                            <button className='btn-outline fs-16 fw-700' onClick={handleClose}>
                                Cancel
                            </button>
                            <button className='btn-primary fs-16 fw-700' onClick={handleConfirm}>
                                Yes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DeleteModal